/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewLocale } from './CRSFSecReviewLocale';
import {
    CRSFSecReviewLocaleFromJSON,
    CRSFSecReviewLocaleFromJSONTyped,
    CRSFSecReviewLocaleToJSON,
} from './CRSFSecReviewLocale';
import type { CRSFSecReviewScanType } from './CRSFSecReviewScanType';
import {
    CRSFSecReviewScanTypeFromJSON,
    CRSFSecReviewScanTypeFromJSONTyped,
    CRSFSecReviewScanTypeToJSON,
} from './CRSFSecReviewScanType';
import type { CRSFSecReviewStatusType } from './CRSFSecReviewStatusType';
import {
    CRSFSecReviewStatusTypeFromJSON,
    CRSFSecReviewStatusTypeFromJSONTyped,
    CRSFSecReviewStatusTypeToJSON,
} from './CRSFSecReviewStatusType';
import type { Metrics } from './Metrics';
import {
    MetricsFromJSON,
    MetricsFromJSONTyped,
    MetricsToJSON,
} from './Metrics';

/**
 * 
 * @export
 * @interface CRSFSecReviewProcessShort
 */
export interface CRSFSecReviewProcessShort {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessShort
     */
    created: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewProcessShort
     */
    domains?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewProcessShort
     */
    entity_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewProcessShort
     */
    entity_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewProcessShort
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewProcessShort
     */
    issue?: string;
    /**
     * 
     * @type {CRSFSecReviewLocale}
     * @memberof CRSFSecReviewProcessShort
     */
    locale?: CRSFSecReviewLocale;
    /**
     * 
     * @type {{ [key: string]: Metrics; }}
     * @memberof CRSFSecReviewProcessShort
     */
    metrics?: { [key: string]: Metrics; };
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewProcessShort
     */
    no_result_flag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewProcessShort
     */
    original_process_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewProcessShort
     */
    process_id: string;
    /**
     * 
     * @type {CRSFSecReviewStatusType}
     * @memberof CRSFSecReviewProcessShort
     */
    process_status: CRSFSecReviewStatusType;
    /**
     * 
     * @type {CRSFSecReviewScanType}
     * @memberof CRSFSecReviewProcessShort
     */
    scan_type: CRSFSecReviewScanType;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessShort
     */
    updated: number;
}

/**
 * Check if a given object implements the CRSFSecReviewProcessShort interface.
 */
export function instanceOfCRSFSecReviewProcessShort(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "process_status" in value;
    isInstance = isInstance && "scan_type" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function CRSFSecReviewProcessShortFromJSON(json: any): CRSFSecReviewProcessShort {
    return CRSFSecReviewProcessShortFromJSONTyped(json, false);
}

export function CRSFSecReviewProcessShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewProcessShort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'created': json['created'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
        'entity_logo_url': !exists(json, 'entity_logo_url') ? undefined : json['entity_logo_url'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'issue': !exists(json, 'issue') ? undefined : json['issue'],
        'locale': !exists(json, 'locale') ? undefined : CRSFSecReviewLocaleFromJSON(json['locale']),
        'metrics': !exists(json, 'metrics') ? undefined : (mapValues(json['metrics'], MetricsFromJSON)),
        'no_result_flag': !exists(json, 'no_result_flag') ? undefined : json['no_result_flag'],
        'original_process_id': !exists(json, 'original_process_id') ? undefined : json['original_process_id'],
        'process_id': json['process_id'],
        'process_status': CRSFSecReviewStatusTypeFromJSON(json['process_status']),
        'scan_type': CRSFSecReviewScanTypeFromJSON(json['scan_type']),
        'updated': json['updated'],
    };
}

export function CRSFSecReviewProcessShortToJSON(value?: CRSFSecReviewProcessShort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created': value.created,
        'domains': value.domains,
        'entity_logo_url': value.entity_logo_url,
        'entity_name': value.entity_name,
        'ip_addresses': value.ip_addresses,
        'issue': value.issue,
        'locale': CRSFSecReviewLocaleToJSON(value.locale),
        'metrics': value.metrics === undefined ? undefined : (mapValues(value.metrics, MetricsToJSON)),
        'no_result_flag': value.no_result_flag,
        'original_process_id': value.original_process_id,
        'process_id': value.process_id,
        'process_status': CRSFSecReviewStatusTypeToJSON(value.process_status),
        'scan_type': CRSFSecReviewScanTypeToJSON(value.scan_type),
        'updated': value.updated,
    };
}

